import * as React from 'react';
import { observer } from 'mobx-react';
import { AnsweredQuestionnaireDto, emptyAnsweredQuestionnaire } from '../../../pages/answeredQuestionnaireTypes';
import AnsweredQuestionCatalogue from './AnsweredQuestionCatalogue';
import Questionnaire from '../common/Questionnaire';
import { observable } from 'mobx';

interface Props {
  answeredQuestionnaire: AnsweredQuestionnaireDto,
  questionnaireId: number,
  enableComment: boolean,
  errorPage: JSX.Element
}

@observer
class AnsweredQuestionnaire extends React.Component<Props> {

  @observable
  private questionnaire: AnsweredQuestionnaireDto = emptyAnsweredQuestionnaire();

  constructor(props: Props) {
    super(props);
    this.updateQuestionnaire = this.updateQuestionnaire.bind(this);
    this.questionnaire = props.answeredQuestionnaire
  }

  public render() {
    return (
      <Questionnaire
        questionnaire={this.questionnaire}>
        {{
          errorPage: this.props.errorPage,
          catalogue: this.renderCatalogue()
        }}
      </Questionnaire>
    )
  }

  private renderCatalogue() {
    return (
      <AnsweredQuestionCatalogue enableComment={this.props.enableComment}
                                 updateQuestionnaire={this.updateQuestionnaire}
                                 questionnaireId={this.props.questionnaireId}
                                 answeredModules={this.questionnaire.modules}/>
    )
  }

  private updateQuestionnaire(updatedQuestionnaire: AnsweredQuestionnaireDto) {
        this.questionnaire = updatedQuestionnaire
  }
}

export default AnsweredQuestionnaire;
